import { render, staticRenderFns } from "./AdminLimits.vue?vue&type=template&id=e0491552"
import script from "./AdminLimits.vue?vue&type=script&lang=js"
export * from "./AdminLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports